import { TenantJob } from '~/tenants/common/TenantJob';
import { MpiOrderContext, MpiOrderType, MpiPerformableConfig } from '~/tenants/mpi/model/MpiOrder';
import { MpiProviderId } from '~/tenants/mpi/model/MpiProvider';

export default abstract class MpiJob<P extends MpiPerformableConfig = MpiPerformableConfig> extends TenantJob<
  MpiOrderContext,
  P
> {
  get editor(): string | null {
    if (this.editing) {
      return MpiProviderId.PURE_COLOR.toString();
    }

    return null;
  }

  get eligible() {
    return this.order.metadata.type !== MpiOrderType.COMMERCIAL;
  }
}
